// GA4 event helpers. No-op until REACT_APP_GA4_ID is set (gtag bootstrapped in index.js).
// Duplicate guards: one page_view per path change, one form_start per form per page view.
let lastPath = null;
const started = new Set();

export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag("event", event, params);
  } catch (e) { /* analytics must never break the app */ }
}

export function trackPageView(path) {
  if (path === lastPath) return;
  lastPath = path;
  started.clear();
  track("page_view", { page_path: path, page_location: window.location.origin + path, page_title: document.title });
}

export function trackFormStart(formId) {
  if (started.has(formId)) return;
  started.add(formId);
  track("form_start", { form_id: formId, page_path: window.location.pathname });
}

export function trackFormSubmit(formId, category) {
  track("form_submit", { form_id: formId, category, page_path: window.location.pathname });
}

export function trackLead(formId, category) {
  track("generate_lead", { form_id: formId, form_location: formId, category, page_path: window.location.pathname });
}
